var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "8. Eror"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6f6",
    d: "M440,480H72A64,64,0,0,1,8,416a16,16,0,0,1,16-16H488a16,16,0,0,1,16,16A64,64,0,0,1,440,480Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M440,456H72a64,64,0,0,1-61.94-47.84A15.88,15.88,0,0,0,8,416a64,64,0,0,0,64,64H440a64,64,0,0,0,64-64,15.88,15.88,0,0,0-2.06-7.84A64,64,0,0,1,440,456Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,488H360a8,8,0,0,1,0-16h80a56.06,56.06,0,0,0,56-56,8,8,0,0,0-8-8H24a8,8,0,0,0-8,8,56.06,56.06,0,0,0,56,56H328a8,8,0,0,1,0,16H72A72.08,72.08,0,0,1,0,416a24,24,0,0,1,24-24H488a24,24,0,0,1,24,24A72.08,72.08,0,0,1,440,488Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596060",
    d: "M301.17,440H210.83A16,16,0,0,1,196,429.94L184,400H328l-12,29.94A16,16,0,0,1,301.17,440Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.17,448H210.83a23.88,23.88,0,0,1-22.28-15.09l-12-29.94A8,8,0,0,1,184,392H328a8,8,0,0,1,7.43,11l-12,29.94A23.87,23.87,0,0,1,301.17,448ZM195.82,408l7.58,19a8,8,0,0,0,7.43,5h90.34a8,8,0,0,0,7.43-5l7.58-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M56,64H456a32,32,0,0,1,32,32V400a0,0,0,0,1,0,0H24a0,0,0,0,1,0,0V96A32,32,0,0,1,56,64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 464,
    height: 24,
    x: 24,
    y: 376,
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488,408H24a8,8,0,0,1,0-16H480V96a24,24,0,0,0-24-24H56A24,24,0,0,0,32,96V368a8,8,0,0,1-16,0V96A40,40,0,0,1,56,56H456a40,40,0,0,1,40,40V400A8,8,0,0,1,488,408Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 304,
    x: 56,
    y: 96,
    fill: "#a8edfd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 24,
    x: 56,
    y: 376,
    fill: "#8bd4de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,408H56a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H456a8,8,0,0,1,8,8V400A8,8,0,0,1,456,408ZM64,392H448V104H64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9a648",
    d: "M349.32,224H162.68a18.7,18.7,0,0,1-15.88-28.52l97-156.68a14.37,14.37,0,0,1,24.42,0l97,156.68A18.7,18.7,0,0,1,349.32,224Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d08840",
    d: "M363.76,193.16A18.64,18.64,0,0,1,349.32,200H162.68a18.64,18.64,0,0,1-14.44-6.84l-1.44,2.32A18.71,18.71,0,0,0,162.68,224H349.32A18.69,18.69,0,0,0,368,205.32C368,199.63,365.72,196.32,363.76,193.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.32,232H162.68c-20.91,0-33.62-23.06-22.68-40.73L237,34.59a22.35,22.35,0,0,1,38,0l97,156.68C382.92,208.91,370.26,232,349.32,232ZM250.59,43l-97,156.68A10.7,10.7,0,0,0,162.68,216H349.32a10.7,10.7,0,0,0,9.08-16.31L261.41,43A6.37,6.37,0,0,0,250.59,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 152a8 8 0 01-8-8V96a8 8 0 0116 0v48A8 8 0 01256 152zM256 192a8 8 0 118-8A8 8 0 01256 192zM144 344H112a8 8 0 01-8-8V272a8 8 0 018-8h32a8 8 0 010 16H120v48h24a8 8 0 010 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 312H112a8 8 0 010-16h24a8 8 0 010 16zM188.88 320H176a8 8 0 01-8-8V272a8 8 0 018-8h12.88A27.16 27.16 0 01216 291.12v1.76A27.16 27.16 0 01188.88 320zM184 304h4.88A11.13 11.13 0 00200 292.88v-1.76A11.13 11.13 0 00188.88 280H184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 344a8 8 0 01-8-8V280a8 8 0 0116 0v56A8 8 0 01176 344zM208 344a8 8 0 01-7-4.19l-13-24A8 8 0 11202 308.19l13 24A8 8 0 01208 344zM253.4 320H240a8 8 0 01-8-8V272a8 8 0 018-8h13.4A26.63 26.63 0 01280 290.6v2.8A26.63 26.63 0 01253.4 320zM248 304h5.4A10.61 10.61 0 00264 293.4v-2.8A10.61 10.61 0 00253.4 280H248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 344a8 8 0 01-8-8V280a8 8 0 0116 0v56A8 8 0 01240 344zM272 344a8 8 0 01-7.27-4.67l-11-24a8 8 0 1114.54-6.66l11 24A8 8 0 01272 344zM380.88 320H368a8 8 0 01-8-8V272a8 8 0 018-8h12.88A27.16 27.16 0 01408 291.12v1.76A27.16 27.16 0 01380.88 320zM376 304h4.88A11.13 11.13 0 00392 292.88v-1.76A11.13 11.13 0 00380.88 280H376z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 344a8 8 0 01-8-8V280a8 8 0 0116 0v56A8 8 0 01368 344zM400 344a8 8 0 01-7-4.19l-13-24A8 8 0 11394 308.19l13 24A8 8 0 01400 344zM320 344a24 24 0 01-24-24V288a24 24 0 0148 0v32A24 24 0 01320 344zm0-64a8 8 0 00-8 8v32a8 8 0 0016 0V288A8 8 0 00320 280z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.27b3e27a0816203ba1e2460ff9f99798.svg";
export { ForwardRef as ReactComponent };